/*
* @Author: jack
* @Date:   2020-01-05 16:45:08
* @Last Modified by:   jack
* @Last Modified time: 2022-08-12 14:44:28
*/
import request from '@/utils/request'

export function share(data) {
  return request({
    url: 'wechat/share',
    method: 'post',
    data
  })
}
export function sharenum(data) {
  return request({
    url: 'acitvity/dati/user/sharenum',
    method: 'post',
    data
  })
}

export function getAcitvityInfo(data) {
  return request({
    //url: 'acitvity/index',
    url: 'json'+ process.env.VUE_APP_PATH +'.json?v=1.2.9',
    method: 'get',
    data
  })
}


export function upload(file) {
  let data = new FormData()
  data.append('file', file)
  return request({
    headers: { 
      'Content-Type': 'multipart/form-data',
      // 'Authorization': 'Bearer ' + getToken()
    },
    url: '/upload/file',
    method: 'post',
    data
  })
}

export function submitDo(data){
  return request({
    url: 'sheying/post',
    method: 'post',
    data
  })
}
export function sheying(data){
  return request({
    url: 'sheying/index',
    method: 'post',
    data
  })
}